<template>
  <div>
    <header class="header-static">
      <a
        class="open-modal close-button"
        :href="closeButtonUrlWithAnchor"
      >
        <span class="icon-cross" />
      </a>
    </header>
    <div v-cloak class="small-12 medium-12 large-8">
      <h1 data-test-status-info-header v-html="value.label" />
      <p data-test-status-info-body v-html="value.text" />
      <div class="row">
        <div class="columns medium-5 small-12">
          <button
            class="button large secondary"
            data-test-status-info-back
            @click="onBackClick"
            v-html="value.backLabel"
          />
        </div>
        <div class="columns medium-5 small-12">
          <button
            class="button large"
            data-test-status-info-submit
            @click="onMinSideClick"
            v-html="value.submitLabel"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { InfoText } from '../../../../../store/modules/interfaces/paymentFrequencyStoreState';
import { defineComponent, PropType } from 'vue';

export default defineComponent({
  props: {
    value: {
      type: Object as PropType<InfoText>
    }
  },
    computed: {
        closeButtonUrlWithAnchor(): string {
            const anchor = this.value.externalPolicyNumber !== null ? '#' + this.value.externalPolicyNumber : '';
            return `${this.value.closeButtonUrl}${anchor}`;
        }
    },
  methods: {
    onBackClick(): void {
      location.href = this.value.backUrl;
    },
    onMinSideClick(): void {
      location.href = this.value.closeButtonUrl;
    }
  }
});
</script>
